import React from 'react';
import { Link } from 'react-router-dom';

// The app is where the full StarView experience lives - this page says so
// plainly. Store links are wired through one constant each so the moment
// the App Store / Play listings go live, two URLs light the badges up
// everywhere on the site.
export const IOS_APP_URL = ''; // set when the App Store listing is live
export const ANDROID_APP_URL = ''; // set when the Play listing is live

const FEATURES = [
  ['🎬', 'Theater rooms', 'Trailer lobbies, seat selection and the feature itself - a real cinema night, per country.'],
  ['✦', 'Galaxies & Loyalty', 'Earn points on every ticket, spend Galaxies, redeem real rewards.'],
  ['⚡', 'Blast Pass', '100 levels of rewards that fill as you watch.'],
  ['🍔', 'OrderUp', 'Dinner delivered to your movie night, with live driver tracking.'],
  ['🎉', 'Watch parties', 'Synchronized private screenings with friends anywhere on Earth.'],
];

function Badge({ href, children }) {
  const style = {
    display: 'inline-flex', alignItems: 'center', gap: 8, padding: '11px 22px', borderRadius: 12,
    fontWeight: 800, textDecoration: 'none', border: '1px solid rgba(255,255,255,0.35)',
    color: href ? '#141021' : 'rgba(255,255,255,0.75)', background: href ? '#fff' : 'transparent',
  };
  return href
    ? <a href={href} style={style} target="_blank" rel="noopener noreferrer">{children}</a>
    : <span style={style} title="Store listing launching soon">{children} · soon</span>;
}

export default function GetTheApp() {
  return (
    <main style={{ minHeight: '70vh', background: '#0b0c1e', color: '#fff', padding: '110px 20px 60px' }}>
      <div style={{ maxWidth: 820, margin: '0 auto', textAlign: 'center' }}>
        <p style={{ fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#CFAA41', fontWeight: 700 }}>The StarView app</p>
        <h1 style={{ fontSize: 36, margin: '6px 0' }}>The whole cinema, in your pocket</h1>
        <p style={{ opacity: 0.75, maxWidth: 540, margin: '0 auto 26px' }}>
          Tickets bought here work in the app instantly - one account everywhere. The app adds everything
          a website can't hold.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 34 }}>
          <Badge href={IOS_APP_URL}> iOS</Badge>
          <Badge href={ANDROID_APP_URL}>▶ Android</Badge>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14, textAlign: 'left' }}>
          {FEATURES.map(([icon, title, body]) => (
            <div key={title} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 14, padding: '18px' }}>
              <span aria-hidden="true" style={{ fontSize: 22 }}>{icon}</span>
              <h3 style={{ margin: '8px 0 6px', fontSize: 16 }}>{title}</h3>
              <p style={{ opacity: 0.72, margin: 0, fontSize: 14 }}>{body}</p>
            </div>
          ))}
        </div>
        <p style={{ opacity: 0.6, fontSize: 13, marginTop: 26 }}>
          Already have tickets? They're waiting in <Link to="/account" style={{ color: '#38BDF8' }}>your account</Link>.
        </p>
      </div>
    </main>
  );
}
